import React from 'react'
import { Details } from '@/components/Details'

function DetailsBlock({ header, content }: { header: string; content: string }) {
  return (
    <Details 
      header={header}
      content={content}
    />
  )
}

export { DetailsBlock }
export default DetailsBlock
